import React from 'react';
import { Tooltip, TooltipBody } from '@ubeya/shared-web/components';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';

const TotalSalaryWithVatRenderer = ({
  rowData: { summarized, subRows, payrollTotal, payroll },
  columnData: { vat }
}) => {
  const formattingMap = useFormattingMap();

  if (subRows || summarized) {
    return <>{formattingMap.currency(payrollTotal * (vat || 1))}</>;
  }

  return (
    <Tooltip
      body={<TooltipBody body={payroll?.calculationString} maxWidth={400} center={false} />}
      disabled={!payroll?.calculationString}>
      <div>{formattingMap.currency((payroll?.value || 0) * (vat || 1))}</div>
    </Tooltip>
  );
};

export default TotalSalaryWithVatRenderer;
